var _g, _path, _path2, _path3, _g2, _g3, _g4, _g5, _g6, _path4, _g7, _path5, _g8, _g9, _g0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdVer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 210,
    viewBox: "0 0 250 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_g_7247_5599)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 53,
    width: 164,
    height: 99,
    rx: 14,
    fill: "#99CCEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.75,
    y: 54.75,
    width: 160.5,
    height: 95.5,
    rx: 12.25,
    stroke: "black",
    strokeWidth: 3.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.069 79.1729C233.13 79.2096 233.16 79.4112 233.264 79.4785C233.465 79.6129 233.801 79.6374 233.911 79.8573C234.1 80.224 233.874 80.9879 233.996 81.159C234.118 81.3301 234.942 81.0551 234.85 82.1245C234.807 82.6562 234.332 82.8701 234.173 83.1267C233.795 83.7317 234.173 84.0189 233.13 84.355C232.843 84.4467 232.666 84.0678 232.434 84.6911C231.745 84.1962 230.665 84.3734 230.061 83.7684C229.933 83.6401 229.963 83.3651 229.835 83.2612C229.738 83.1817 229.481 83.2306 229.365 83.0778C229.158 82.8151 229.103 81.5623 229.213 81.2445C229.304 80.9879 229.561 80.9207 229.652 80.7312C229.768 80.4868 229.701 80.2179 229.866 79.9246C229.963 79.7535 230.72 79.124 230.903 79.0629C231.257 78.9407 232.794 79.0079 233.056 79.1668L233.069 79.1729Z",
    fill: "#0E231E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.202 103.449C230.153 103.431 229.464 102.734 229.433 102.692C229.256 102.417 229.305 102.019 229 101.805L229.287 101.647C229.275 100.412 229.897 98.9699 231.294 99.0005C231.642 99.0066 231.752 99.2633 232.026 99.3549C232.496 99.5138 232.862 99.2571 233.21 99.9232C233.533 100.559 233.216 100.669 233.246 101.084C233.265 101.31 233.496 101.457 233.466 101.726C233.454 101.836 233.185 102.844 233.155 102.899C233.118 102.96 232.112 103.749 231.977 103.779C231.825 103.81 230.336 103.504 230.202 103.449Z",
    fill: "#0E231E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.11 94.2361L219.128 94.5111L219.409 94.615C219.531 95.1283 218.201 96.2161 217.7 96.3994C217.261 96.0633 216.968 96.375 216.852 96.3689C216.73 96.3628 216.584 96.1672 216.407 96.1428C216.163 96.1061 215.553 96.1917 215.473 96.1122C215.431 96.0756 215.492 95.8311 215.425 95.7456C215.144 95.4156 214.711 95.2017 214.387 94.6761C214.333 94.5784 214.455 94.3584 214.369 94.2361C214.217 94.0284 213.759 94.1995 214.162 93.4723C214.235 93.3378 214.418 93.3317 214.491 93.1667C214.76 92.5373 214.516 91.9628 215.174 91.089C215.516 90.6368 216.443 90.2273 216.999 90.2823C217.31 90.3129 217.487 90.7101 217.798 90.8079C218.335 90.9729 218.823 90.6734 219.183 91.3212C219.543 91.969 219.372 92.3784 219.439 92.9528C219.5 93.4845 220.128 93.9978 219.122 94.2361H219.11Z",
    fill: "#0E231E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_g_7247_5599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 99H143.235",
    stroke: "#0E231E",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_g_7247_5599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 88H181",
    stroke: "#0E231E",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_g_7247_5599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.923 99H189.42",
    stroke: "#0E231E",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_g_7247_5599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 117H142",
    stroke: "#0E231E",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_g_7247_5599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148 117H171",
    stroke: "#0E231E",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5599 63.2544C25.1764 62.5322 24.9537 61.8261 24.1642 61.5169C24.1422 60.9131 24.7705 60.4579 24.5916 59.7591C24.5297 59.5071 24.8723 59.1987 24.4291 58.9266C24.2942 58.8421 24.3733 58.4079 24.3517 58.128C24.8866 58.2079 24.4949 57.63 24.7921 57.5157C25.1163 57.3872 25.2441 57.2324 24.9139 56.8929C24.692 56.6657 24.5411 56.3039 24.4971 55.9863C24.4432 55.5764 24.5211 55.2293 24.1303 54.8474C23.5788 54.3079 23.223 53.6124 22.5631 53.1021C21.7045 52.4431 20.7388 52.0229 19.8281 51.4874C19.4126 51.242 19.1369 50.76 18.7564 50.3425C19.0065 50.1855 19.2787 50.0389 19.2701 50.0146C19.0309 49.4421 20.0276 49.1895 19.6302 48.5955C20.0035 48.1803 20.354 47.7139 21.0111 47.7779C21.3328 47.8101 21.6676 47.8147 21.9608 47.9209C22.1689 47.9932 22.5642 47.5886 22.5963 48.1431C23.655 48.001 24.8089 48.5919 25.7591 47.5892C26.0981 47.2318 26.6614 47.0826 27.1251 46.8454C27.303 46.755 27.5233 46.7455 27.679 46.631C27.8051 46.5361 27.8835 46.3578 27.9513 46.2014C27.9985 46.1026 27.9303 45.9487 27.9887 45.8687C28.0921 45.7226 28.2727 45.6267 28.3761 45.4805C28.4874 45.3179 28.652 45.0999 28.6139 44.9536C28.4446 44.3335 28.7072 43.9667 29.177 43.6178C29.2817 43.5397 29.2021 43.2119 29.2122 43.0212C29.6351 42.6433 30.3272 42.8318 30.6103 42.2523C30.6313 42.2084 30.9831 42.2481 30.9919 42.2861C31.1054 42.8255 31.6806 42.4393 31.8486 42.6947C32.1541 43.1707 32.3601 43.7139 32.6333 44.215C32.8024 44.5248 32.6353 44.762 32.5752 45.0434C32.3971 45.855 32.1972 46.6696 32.4469 47.5168C32.537 47.8226 32.6061 48.1724 32.552 48.4837C32.4253 49.2861 32.707 49.7979 33.463 50.0642C33.6027 50.1106 33.8323 50.1662 33.8503 50.2557C34.0785 51.2611 35.0506 51.1451 35.7007 51.4215C36.3534 51.6924 36.8302 52.1625 37.301 52.6028C37.65 52.9311 37.7134 53.5613 37.7818 53.7287C37.8703 54.3911 37.2055 54.202 37.4184 54.6743C37.4468 54.7418 37.1597 54.9622 37.0126 55.101C36.7132 55.3895 36.4414 55.7048 36.1057 55.9424C35.6786 56.2442 35.4077 56.0206 35.2229 55.4471C34.9355 56.092 34.5853 56.4305 33.8812 56.3238C33.4418 56.2558 32.9179 56.6193 32.5049 56.5099C31.9798 56.3672 31.7705 57.1168 31.2531 56.8025C31.1788 56.7604 30.9154 57.0864 30.7132 57.1854C30.5028 57.2873 30.2255 57.3033 30.4387 57.6477C30.45 57.6665 30.4348 57.7267 30.4107 57.7489C30.224 57.9565 29.7487 57.7095 29.7234 58.2569C29.711 58.4667 29.5286 58.9055 29.3641 58.982C28.8593 59.2064 29.2616 59.6208 29.1103 59.8249C28.8183 60.225 28.4025 60.5456 28.0093 60.9176C28.0925 60.9977 28.2226 61.1205 28.5497 61.4382C28.1205 61.3346 27.8307 61.2638 27.5354 61.1904C27.6057 62.0463 27.91 62.7509 26.9891 62.5476C26.929 62.5324 26.784 62.6385 26.7743 62.7012C26.6443 63.4684 25.999 63.0123 25.5458 63.2275L25.5599 63.2544ZM29.243 50.4038C27.9296 50.4581 27.2298 51.3174 26.3639 51.875C26.7832 52.9177 27.6884 53.5921 27.847 54.6587C28.3334 54.4728 28.7713 54.3177 29.1266 53.8131C29.3547 53.4905 29.7887 52.6796 30.5665 53.2394C30.6933 53.3268 30.9288 53.2571 31.2228 53.2626C30.3619 52.1846 29.3604 51.599 29.2349 50.4066L29.243 50.4038Z",
    fill: "#0E231E"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_g_7247_5599)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 126.5,
    r: 27.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 126.5,
    r: 25.75,
    stroke: "#0E231E",
    strokeWidth: 3.5
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88 133C76 133 71 140.367 70 144.05C72.3333 146.033 79.2 151 88 151C96.8 151 103.667 145.75 106 143.625C105 140.083 100 133 88 133Z",
    fill: "#3B6890"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_g_7247_5599)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 117.5,
    r: 9.5,
    fill: "#3B6890"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 117.5,
    r: 7.75,
    stroke: "#0E231E",
    strokeWidth: 3.5
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_g_7247_5599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.5 145C105.5 141.5 97.9934 132 87.5 132C77.0066 132 70.5 140.5 70.5 146",
    stroke: "#0E231E",
    strokeWidth: 3.5
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_g_7247_5599)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 139.5,
    r: 30.75,
    fill: "#CBDC66",
    stroke: "#0E231E",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.648 139.93L192.238 151.537L213.148 127.463",
    stroke: "#0E231E",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_g_7247_5599",
    x: 40.7,
    y: 52.7,
    width: 164.6,
    height: 99.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.56147581338882446 0.56147581338882446",
    numOctaves: 3,
    seed: 4187
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 0.6000000238418579,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_7247_5599"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_g_7247_5599",
    x: 116.95,
    y: 96.95,
    width: 28.3354,
    height: 4.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.56147581338882446 0.56147581338882446",
    numOctaves: 3,
    seed: 4187
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 0.6000000238418579,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_7247_5599"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_g_7247_5599",
    x: 116.95,
    y: 85.95,
    width: 66.1,
    height: 4.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.56147581338882446 0.56147581338882446",
    numOctaves: 3,
    seed: 4187
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 0.6000000238418579,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_7247_5599"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_g_7247_5599",
    x: 149.873,
    y: 96.95,
    width: 41.5962,
    height: 4.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.56147581338882446 0.56147581338882446",
    numOctaves: 3,
    seed: 4187
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 0.6000000238418579,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_7247_5599"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_g_7247_5599",
    x: 116.95,
    y: 114.95,
    width: 27.1,
    height: 4.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.56147581338882446 0.56147581338882446",
    numOctaves: 3,
    seed: 4187
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 0.6000000238418579,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_7247_5599"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_g_7247_5599",
    x: 145.95,
    y: 114.95,
    width: 27.1,
    height: 4.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.56147581338882446 0.56147581338882446",
    numOctaves: 3,
    seed: 4187
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 0.6000000238418579,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_7247_5599"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_g_7247_5599",
    x: 59.7,
    y: 98.7,
    width: 55.6,
    height: 55.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.56147581338882446 0.56147581338882446",
    numOctaves: 3,
    seed: 4187
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 0.6000000238418579,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_7247_5599"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_g_7247_5599",
    x: 77.7,
    y: 107.7,
    width: 19.6,
    height: 19.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.56147581338882446 0.56147581338882446",
    numOctaves: 3,
    seed: 4187
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 0.6000000238418579,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_7247_5599"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_g_7247_5599",
    x: 68.45,
    y: 129.95,
    width: 39.1,
    height: 16.35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.56147581338882446 0.56147581338882446",
    numOctaves: 3,
    seed: 4187
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 0.6000000238418579,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_7247_5599"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_g_7247_5599",
    x: 164.7,
    y: 106.7,
    width: 65.6,
    height: 65.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.56147581338882446 0.56147581338882446",
    numOctaves: 3,
    seed: 4187
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 0.6000000238418579,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_7247_5599"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdVer);
export default __webpack_public_path__ + "static/media/IDVer.55b7e6dcb95623cd97a93a3cd83f9ef5.svg";
export { ForwardRef as ReactComponent };